// extracted by mini-css-extract-plugin
export default {"close":"dialog-components_close__2zu-v","info":"dialog-components_info__WsGcQ"};